/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type StatExport = 'contractNotice' | 'statsMyParcelsInOtherUserLb' | 'statsMyParcelsOutsideLb' | 'statsOthersParcelsInMyLb' | 'parcelEstateNew' | 'parcelEstateDefunct' | 'parcelEstateChange' | 'parcelEstateCoowners' | 'reporting' | 'reportingEstateKatuzeDrupoz';

export const StatExport = {
    contractNotice: 'contractNotice' as StatExport,
    statsMyParcelsInOtherUserLb: 'statsMyParcelsInOtherUserLb' as StatExport,
    statsMyParcelsOutsideLb: 'statsMyParcelsOutsideLb' as StatExport,
    statsOthersParcelsInMyLb: 'statsOthersParcelsInMyLb' as StatExport,
    parcelEstateNew: 'parcelEstateNew' as StatExport,
    parcelEstateDefunct: 'parcelEstateDefunct' as StatExport,
    parcelEstateChange: 'parcelEstateChange' as StatExport,
    parcelEstateCoowners: 'parcelEstateCoowners' as StatExport,
    reporting: 'reporting' as StatExport,
    reportingEstateKatuzeDrupoz: 'reportingEstateKatuzeDrupoz' as StatExport
};

